
(function() {
  
  function waitForElm(selector) {
      return new Promise(resolve => {
          if (document.querySelector(selector)) {
              return resolve(document.querySelector(selector));
          }

          const observer = new MutationObserver(mutations => {
              if (document.querySelector(selector)) {
                  observer.disconnect();
                  resolve(document.querySelector(selector));
              }
          });

          // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
          observer.observe(document.body, {
              childList: true,
              subtree: true
          });
      });
  }


  function resetSubItemInputs() {
    const subItemCards = Array.from(document.querySelectorAll('.rb-box-builder [data-rb-item-id] input[type=text]'));

    console.log('cdebug subItemCards', subItemCards)

    subItemCards.forEach((subItemCard) => {
      if(subItemCard) {
        subItemCard.value = 0;

        var event = new Event('change');
        subItemCard.dispatchEvent(event);
      }
    });

  }

  function clearFlexOrders() {
    const rbItems = Array.from(document.querySelectorAll('[data-rb-item-id]'));

    rbItems.forEach((rbItem) => {
      if(rbItem) {
        rbItem.style.order = null;
      }
    })

  }


  function setSubItemInputs() {

    // What's the current variant?
    const currentVariantId = window.location.search.split('variant=')[1] || window.firstAvailableVariant
    // What's the config under the current variant?
    const currentVariantConfig = window.themeBundleConfig.find((element) => {
      return element.variantId == currentVariantId;
    });

    const subVariants = currentVariantConfig?.subVariants ? currentVariantConfig.subVariants.sort(function(a, b) {
      return b.quantity - a.quantity;
    }) : []

    console.log('cdebug currentVariantId', currentVariantId)
    console.log('cdebug currentVariantConfig', currentVariantConfig)
    console.log('cdebug subVariants', subVariants)

    // Clear flexOrders
    clearFlexOrders();

    if(currentVariantConfig) {
      
      subVariants.forEach((subVariant) => {
        const subVariantContainerEl = document.querySelector(`.rb-box-builder [data-rb-item-id='${subVariant.productId}']`);
        const subVariantEl = document.querySelector(`.rb-box-builder [data-rb-item-id='${subVariant.productId}'] input[type=text]`);



        console.log('cdebug subVariantContainerEl', subVariantContainerEl);
        console.log('cdebug subVariantEl', subVariantEl);

        if(subVariantContainerEl) {
          subVariantContainerEl.style.order = subVariant.quantity * -1;
        }

        if(subVariantEl) {
          subVariantEl.value = subVariant.quantity;

          var event = new Event('change');
          subVariantEl.dispatchEvent(event);

        }

      })

    }

  }


  document.addEventListener('bundling-widget:ready', function(e){
    console.log('cdebug bundling-widget:ready', e);

    
    const rechargeBundleContainer = document.querySelector('#recharge-bundles');
  
    rechargeBundleContainer && rechargeBundleContainer.classList.add('loading');

    waitForElm('.rb-box-builder [data-rb-item-id] input[type=text]').then((elm) => {
      resetSubItemInputs();
      setSubItemInputs();
      rechargeBundleContainer && rechargeBundleContainer.classList.remove('loading');
    });

  });

  window.updateBundleSelection = function() {
    const rechargeBundleContainer = document.querySelector('#recharge-bundles');
  
    rechargeBundleContainer && rechargeBundleContainer.classList.add('loading');
    
    var timeOut = setTimeout(() => {
        resetSubItemInputs();
        setSubItemInputs();
        rechargeBundleContainer && rechargeBundleContainer.classList.remove('loading');

        clearTimeout(timeOut);
      }, 1000)
  };



})();